import * as React from 'react'

const SvgCloseBig = ({
  width,
  className,
}: {
  width: number
  className?: string
}) => (
  <svg
    className={className}
    width={width}
    height={width}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3043 10.8901L7.70811 6.2939C7.32256 5.90834 6.68445 5.9034 6.29392 6.29392C5.90068 6.68717 5.90339 7.3176 6.2939 7.70811L10.8901 12.3043L6.2939 16.9006C5.90834 17.2861 5.9034 17.9242 6.29392 18.3147C6.68717 18.708 7.3176 18.7053 7.70811 18.3148L12.3043 13.7185L16.9006 18.3148C17.2861 18.7003 17.9242 18.7053 18.3147 18.3147C18.708 17.9215 18.7053 17.2911 18.3148 16.9006L13.7185 12.3043L18.3148 7.70811C18.7003 7.32256 18.7053 6.68445 18.3147 6.29392C17.9215 5.90068 17.2911 5.90339 16.9006 6.2939L12.3043 10.8901Z"
      fill="currentColor"
    />
  </svg>
)
export default SvgCloseBig
